import { useBEM } from '../utils/classnames';
export const classesMixin = ( name ) => {
    let classnames = useBEM( `hanzo-${ name }` );
    return {
        methods: {
            classes( ...args ) {
                return classnames( ...args );
            }
        }
    }
  };